<template>
    <div>
        <div class="splash-screen">
            <!--<i class="close fa fa-times" @click="closeSplashScreen"></i> -->
            <header class="cabecera">
                <h1 class="titulo">
                    <span>Portal Interactivo de<br/> Fiscalización Ambiental</span>
                </h1>
                <small class="subtitulo">
                    <strong>Sistema de Información Geográfico</strong>
                    <span>Coordinación de Sistemas de información Geográfica - CSIG</span>
                </small>
            </header>
            <section>
            </section>
            <footer class="footer">
                <button class="btn btn-primary" @click="closeSplashScreen">Ingresar</button>
            </footer>
        </div>
        <div class="sombra"></div>
    </div>

</template>

<script>
    const config = splash_config;
    export default {
        name: "SplashScreen",
        methods:{
            closeSplashScreen(){
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>

</style>
